/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReorderComparablePropertiesItem } from './ReorderComparablePropertiesItem';
import {
    ReorderComparablePropertiesItemFromJSON,
    ReorderComparablePropertiesItemFromJSONTyped,
    ReorderComparablePropertiesItemToJSON,
    ReorderComparablePropertiesItemToJSONTyped,
} from './ReorderComparablePropertiesItem';

/**
 * 
 * @export
 * @interface ReorderComparablePropertiesRequest
 */
export interface ReorderComparablePropertiesRequest {
    /**
     * 
     * @type {Array<ReorderComparablePropertiesItem>}
     * @memberof ReorderComparablePropertiesRequest
     */
    order: Array<ReorderComparablePropertiesItem>;
}

/**
 * Check if a given object implements the ReorderComparablePropertiesRequest interface.
 */
export function instanceOfReorderComparablePropertiesRequest(value: object): value is ReorderComparablePropertiesRequest {
    if (!('order' in value) || value['order'] === undefined) return false;
    return true;
}

export function ReorderComparablePropertiesRequestFromJSON(json: any): ReorderComparablePropertiesRequest {
    return ReorderComparablePropertiesRequestFromJSONTyped(json, false);
}

export function ReorderComparablePropertiesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReorderComparablePropertiesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'order': ((json['order'] as Array<any>).map(ReorderComparablePropertiesItemFromJSON)),
    };
}

export function ReorderComparablePropertiesRequestToJSON(json: any): ReorderComparablePropertiesRequest {
    return ReorderComparablePropertiesRequestToJSONTyped(json, false);
}

export function ReorderComparablePropertiesRequestToJSONTyped(value?: ReorderComparablePropertiesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'order': ((value['order'] as Array<any>).map(ReorderComparablePropertiesItemToJSON)),
    };
}

